import { Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProductService } from '../../services/product.service';
import { Product, Category } from '../../models/product.model';
import { ProductCardComponent } from '../../components/product-card/product-card.component';
import { getCategoryImage } from '../../data/category-images';

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterLink, ProductCardComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  protected featuredProducts = signal<Product[]>([]);
  protected categories = signal<Category[]>([]);
  protected isLoading = signal(true);
  protected currentYear = new Date().getFullYear();
  protected getCategoryImage = getCategoryImage;

  constructor(private productService: ProductService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.isLoading.set(true);

    this.productService.getCategories().subscribe(cats => {
      this.categories.set(cats);
    });

    this.productService.getFeaturedProducts(12).subscribe(products => {
      this.featuredProducts.set(products);
      this.isLoading.set(false);
    });
  }
}

